import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ServiceService } from '../../provider/service.service';

@Component({
    selector: 'app-instructors-style-one',
    templateUrl: './instructors-style-one.component.html',
    styleUrls: ['./instructors-style-one.component.scss']
})
export class InstructorsStyleOneComponent implements OnInit {

    instructorSlides: OwlOptions = {
		loop: false,
		nav: true,
		dots: false,
		autoplayHoverPause: true,
		autoplay: true,
		margin: 30,
		navText: [
			"<i class='bx bx-left-arrow-alt'></i>",
			"<i class='bx bx-right-arrow-alt'></i>"
		],
		responsive: {
			0: {
				items: 1
			},
			576: {
				items: 2
			},
			768: {
				items: 2
			},
			1200: {
				items: 3
			}
		}
    }

	userDataPost={"userID":"", "o_companyID":1};
	constructor(public service: ServiceService) { }
  
	ngOnInit(): void {
	  this.get_all_brands();
	}
  
	fslotsData:any; dataSet:any;  fimgURL:any; loading:boolean = false;
	get_all_brands(){
		 this.loading = true;
		 this.service.postData(this.userDataPost, 'get_all_brands').then((result) => {
		   this.fslotsData = result;
		   if (this.fslotsData.brandsData){
			this.loading = false;
		 this.dataSet = this.fslotsData.brandsData;
		 this.fimgURL = this.fslotsData.fimgURL;
		   }else{
		  this.loading = false;
		 this.alert('error', 'Opps! Something went wrong. Kindly Contact to Technical Team.');
		   }
		}, (err) => { 
		this.loading = false;
		this.alert('error', 'Opps! Something went wrong. Kindly Contact to Technical Team.'); 
		});
	  } 
  
  
  /* Alert Message */
  show_alert:boolean = false; message:any;
  alert(type, message){
	this.show_alert = true;
	this.message={'type':type,'text':message};
	setTimeout(() => {
	  this.show_alert = false;
	}, 5000);
  }
  close_alert(){
	this.show_alert = false;
	this.message = '';
  }
  /* End of Alert Message */

}